<main id="content-page">
    <div class="container main-panel">
        <div class="row article-row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="article-wrap">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="text-center">
                                <h1>LawShelf Terms of Service</h1>
                            </div>
                        </div>
                    </div>
                    <app-terms-of-service></app-terms-of-service>
                </div>
            </div>
        </div>
    </div>
</main>